import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} data-testid={`site-toast-${id}`} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle data-testid={`site-toast-title-${id}`}>{title}</ToastTitle>}
              {description && (
                <ToastDescription data-testid={`site-toast-description-${id}`}>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose data-testid={`site-toast-close-${id}`} aria-label="Dismiss notification" />
          </Toast>
        );
      })}
      <ToastViewport data-testid="site-toast-viewport" />
    </ToastProvider>
  );
}
